module.exports = __webpack_public_path__ + "img/investment1.25adaf2c.png";